import DOMPurify from 'dompurify';
/**
 * 富文本安全过滤配置
 * 允许富文本常用标签，同时拦截 script、事件处理器等 XSS 向量
 * 保留 data-* 属性以支持 App.js 中的 img[data-href] 全局点击逻辑
 */
const DEFAULT_CONFIG = {
    FORBID_TAGS: [
        'script', // 脚本标签
        'input', // 输入框
        'form', // 表单
        'button', // 按钮
        'select', // 下拉选择
        'textarea', // 文本域
        'object', // 嵌入对象
        'embed', // 嵌入内容
        'applet', // Java小程序
        'base', // 基础URL
        'meta', // 元数据
        'noscript', // 无脚本内容
        'frame', // 框架
        'frameset' // 框架集
    ],
    ADD_TAGS: ['glink', 'citation'],
    // 允许的默认属性（如 target="_blank"）
    ADD_ATTR: ['target', 'business_id', 'duration', 'type', 'id', 'chunks'],

    // 允许的未知协议
    ALLOW_UNKNOWN_PROTOCOLS: false,
    //    防止 DOM Clobbering 攻击（通过 name/id 覆盖全局变量）
    SANITIZE_DOM: true,
    // 移除危险标签时保留其内部文字内容
    KEEP_CONTENT: true
};

/**
 * 对 HTML 字符串进行 XSS 安全过滤
 * @param {string} html - 待过滤的 HTML 字符串
 * @param {Object} [config] - 可选的 DOMPurify 配置，会与默认配置合并
 * @returns {string} 过滤后的安全 HTML 字符串
 */

/**
 * 需要以纯文本形式展示的标签（不渲染，只显示标签本身）
 */
const TEXTIFY_TAGS = ['input', 'script', 'style', 'textarea', 'select', 'button'];

export function sanitizeHtml(html, config) {
    if (!html || typeof html !== 'string') return '';

    let processed = html;
    // 将指定标签转为 HTML 实体，使其以文本形式显示
    for (const tag of TEXTIFY_TAGS) {
        // 匹配开始标签（含自闭合 <input ... />）
        const startRegex = new RegExp(`<${tag}([^>]*)/?\\s*>`, 'gi');
        processed = processed.replace(startRegex, '&lt;' + tag + '$1&gt;');

        // 匹配结束标签 </script> 等
        const endRegex = new RegExp(`</${tag}\\s*>`, 'gi');
        processed = processed.replace(endRegex, '&lt;/' + tag + '&gt;');
    }

    const mergedConfig = config ? { ...DEFAULT_CONFIG, ...config } : DEFAULT_CONFIG;
    return DOMPurify.sanitize(processed, mergedConfig);
}

export default sanitizeHtml;
